<template>
  <generic-selector
    v-model="localTag"
    item-key="deveui"
    item-label="name"
    :items="tags"
    :title="$t('tag.choose')"
  />
</template>

<script>
import GenericSelector from "./GenericSelector.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "NodeSelector",
  components: { GenericSelector },

  props: {
    value: {
      default: undefined,
    },
  },

  model: { prop: "value" },

  data() {
    return {};
  },

  computed: {
    ...mapState("tag", { tags: "tagsWithInformation" }),

    localTag: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    ...mapActions("tag", ["getTagsWithInformation"]),
  },

  async mounted() {
    await this.getTagsWithInformation();
  },
};
</script>